import { createSlice } from "@reduxjs/toolkit";

const initialState = { groups: [] }

const allGroupSlice = createSlice({
    name: "allGroups",
    initialState,
    reducers: {
        setAllGroupDatas(state, action) {
            state.groups = action.payload
        },
        resetAllGroupsData(state, action) {
            state.groups = []
        }
    }
});

export const {
    setAllGroupDatas, resetAllGroupsData
} = allGroupSlice?.actions

export default allGroupSlice?.reducer